import { render, staticRenderFns } from "./App.vue?vue&type=template&id=84db0956&scoped=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"
import style0 from "./App.vue?vue&type=style&index=0&id=84db0956&prod&lang=scss"
import style1 from "./App.vue?vue&type=style&index=1&id=84db0956&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84db0956",
  null
  
)

export default component.exports